import { AppRouteProps } from '~/routes'
import CustomDashboard from './pages/CustomDashboard'

export default function CustomDashboardRoutes(): readonly AppRouteProps[] {
  const routes: readonly AppRouteProps[] = [
    {
      path: '/custom-dashboard',
      component: CustomDashboard,
      isProtected: true,
      permissions: ['dispatch_index'],
    },
  ]
  return routes
}

